var _rect, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaskImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artwork trailing"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 57,
    rx: 28.5,
    stroke: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3166_18402",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 56,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "mask",
    cx: 29,
    cy: 29,
    r: 28,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3166_18402)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "image",
    x: -13,
    y: 1,
    width: 84,
    height: 56,
    fill: "#39455E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskImg);
export default __webpack_public_path__ + "static/media/Mask_img.dcb1c9b009de3f3c188313fac5617235.svg";
export { ForwardRef as ReactComponent };